import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { rootState } from '../../../../redux/store';
import { Spacing } from '../../../layout/Spacing/Spacing';
import { toggleUserDisplay } from '../userProfile.slice';
import { AvatarLogo } from '../../../shared/AvatarLogo/AvatarLogo';
import { CleanButton } from '../../../ui/CleanButton';
import { Department } from '../Department';
import { LanguageSelect } from '../../Languages/LanguageSelect';
import { SpacingCustom } from '../../../layout/Spacing/SpacingCustom';

export const UserInfo = () => {
    const dispatch = useAppDispatch();
    const { userAndTokenData } = useAppSelector((state: rootState) => state.loginUserAndTokenData);

    return (
        <SpacingCustom>
            <div className="user-info">
                <div className="user-info__text">
                    <div className="user-info__name">
                        {userAndTokenData?.user.surname}, {userAndTokenData?.user.name}
                    </div>
                    <Department />
                    {/* <div className="user-info__department">{userAndTokenData?.user.department === '' ? 'Operator' : transformDepartmentName(userAndTokenData?.user.department || '')}</div> */}
                </div>
                <CleanButton func={() => dispatch(toggleUserDisplay())}>
                    <AvatarLogo size="m" color="accent-blue" userName={userAndTokenData?.user.name || ''} userSurname={userAndTokenData?.user.surname || ''} />
                </CleanButton>
            </div>
        </SpacingCustom>
    );
};
